import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaBrain, FaCode, FaCloud, FaDatabase, FaPaintBrush, FaTasks, FaChartLine, FaCogs, FaChartPie, FaHeadset, FaPlug, FaBook, FaUserCog, FaChalkboard, FaSync } from 'react-icons/fa';
import { FaShield } from 'react-icons/fa6';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'data insights':
      return <FaChartLine />; // Line chart icon

    case 'machine learning':
      return <FaBrain />; // Brain icon

    case 'cloud automation':
      return <FaCloud />; // Cloud icon

    case 'ai integration':
      return <FaCogs />; // Gears icon

    case 'predictive analytics':
      return <FaChartPie />; // Pie chart icon

    case 'support services':
      return <FaHeadset />; // Headset icon


    /*----- Position Icons -----*/
    case 'machine learning engineer':
      return <FaCode />; // Code icon

    case 'ai solutions architect':
      return <FaCloud />; // Cloud icon

    case 'ai product manager':
      return <FaDatabase />; // Database icon

    case 'ai research scientist':
      return <FaPaintBrush />; // Brush icon

    case 'ai software engineer':
      return <FaTasks />; // Tasks icon

    case 'ai ux/ui designer':
      return <FaShield />; // Shield icon


    /*----- Support Button Icons -----*/
    case 'ai support':
      return <FaBrain />; // Brain icon

    case 'cloud services':
      return <FaCloud />; // Cloud icon

    case 'data analytics':
      return <FaChartLine />; // Chart line icon

    case 'integration issues':
      return <FaPlug />; // Plug icon

    case 'support docs':
      return <FaBook />; // Book icon

    case 'account management':
      return <FaUserCog />; // User settings icon

    case 'ai training':
      return <FaChalkboard />; // Chalkboard icon

    case 'tech updates':
      return <FaSync />; // Sync icon


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'time':
    case 'timing':
    case 'hours':
    case 'duration':
      return <FaClock />; // Clock icon

    case 'beneficiaries':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'cost':
    case 'salary':
    case 'fee':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'projectlead':
    case 'organizer':
      return <FaUserTie />; // User Tie icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    default:
      return null; // No matching icon

  }

};